import { create } from 'zustand';
/**
 * 앱 내 전역적으로 포커스 된 아이템을 관리합니다.
 * @param set
 */
var focusedItem = create(function (set) { return ({
    setMoving: function (isMoving) {
        set(function () { return ({
            isMoving: isMoving,
        }); });
        if (!isMoving) {
            set(function () { return ({
                isVerticalMoving: false,
            }); });
        }
    },
    setVerticalMoving: function (isVerticalMoving) {
        set(function () { return ({
            isVerticalMoving: isVerticalMoving,
        }); });
    },
    setLongFocusedItem: function (tvingItem) {
        set(function () { return ({
            longFocusedItem: tvingItem,
        }); });
    },
    setFocusedItem: function (tvingItem) {
        set(function () { return ({
            focusedItem: tvingItem,
        }); });
    },
}); });
export var useFocusedItemStore = focusedItem;
